import { render } from "./RecoveryMain.vue?vue&type=template&id=5fa50fc4&ts=true"
import script from "./RecoveryMain.vue?vue&type=script&lang=ts"
export * from "./RecoveryMain.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/angeloquijano/Git/IWARI/iwari-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__